import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-fiber-supplement',
  imports: [UpsellCardComponent],
  templateUrl: './fiber-supplement.component.html',
  styleUrl: './fiber-supplement.component.scss',
})
export class FiberSupplementComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.FiberSupplement;
}
